module.exports = __webpack_public_path__ + "img/avatar5.f140a4e9.png";